import gql from 'graphql-tag'

const setPriceLinesMutation = gql`
  mutation setPriceLines($priceLines: [PriceLine]) {
    setPriceLines(priceLines: $priceLines) @client
  }
`

export default setPriceLinesMutation
